import React, { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';

import { getProductsList } from '../../../../../services/affiliate.service';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import ModalComponent from '../../../../common-components/ModalComponent/ModalComponent';
import SaralLoaderImage from '../../../../common-components/SaralLoaderImage';
import { BackArrowIcon } from '../../../../Icons';
import VariantSelectionCard from '../../../Lists/components/shipping/VariantSelectionCard';

const SelectVariant = ({
  show,
  onClose,
  selectedProducts,
  setSelectedProducts,
  setQuantities,
  quantities,
  allOptions,
  setAllOptions,
}) => {
  const [loadingVariant, setLoadingVariant] = useState(false);
  const { userDetails } = useSelector((s) => s.user);

  useEffect(() => {
    fetchSelectedProducts();
  }, []);

  const fetchSelectedProducts = async () => {
    setLoadingVariant(true);
    let body = {};
    let productIds = [];
    if (
      import.meta.env.REACT_APP_SARAL_ENV === 'dev' &&
      userDetails.storePlatform === 'shopify' &&
      userDetails.email.includes('getsaral.com')
    ) {
      productIds = ['8061683761441', '8061642539297', '8041269395745'];
      body = {
        productIds,
      };
    } else {
      productIds = selectedProducts.map((p) => p.id);
      body = { productIds };
    }

    const response = await getProductsList(body);
    if (response?.status) {
      setSelectedProducts(response?.data);
      let isSingleVariant = true;
      const quantityObj = {};
      response.data.forEach((data) => {
        quantityObj[data.id] = 1;
      });
      setQuantities(quantityObj);
      response?.data?.forEach((d) => {
        if (d?.variants?.length > 1) isSingleVariant = false;
      });
      setLoadingVariant(false);
      if (isSingleVariant) onClose();
    } else {
      NotificationManager.error('Something went wrong');
      setLoadingVariant(false);
    }
  };

  // clone variant
  const cloneObject = (index) => {
    if (index < 0 || index >= selectedProducts.length) return;
    const id = Date.now().toString();
    const newArray = selectedProducts.map((obj) => ({ ...obj }));
    const clonedObject = { ...newArray[index], id };
    newArray.splice(index + 1, 0, clonedObject);
    setSelectedProducts(newArray);
    setQuantities({ ...quantities, [id]: 1 });
  };

  /**
   * function to check if the Submit button is disabled
   */
  const checkIfDisabled = () => {
    const disabledArray = selectedProducts.map((product) => {
      if (product.options?.[0]?.options?.[0] === 'Default Title') {
        return false;
      } else if (product?.options?.length === 3) {
        return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2 || !allOptions[product.id]?.option3;
      } else if (product?.options?.length === 2) {
        return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2;
      } else if (product?.options?.length === 1) {
        return !allOptions[product.id]?.option1;
      } else {
        return false;
      }
    });
    return !disabledArray.every((ele) => ele === false);
  };

  /**
   * function to remove Product
   */
  const removeProduct = (productId) => {
    if (selectedProducts.length === 1) {
      onClose();
    } else {
      setSelectedProducts(selectedProducts.filter((product) => product.id !== productId));
    }
  };

  return (
    <ModalComponent
      show={show}
      onClose={onClose}
      width={1075}
      outsideClickClose={false}
      style={{ maxHeight: '800px', overflowY: 'scroll' }}>
      <div className="modal-main-content">
        <div className="sl-variant-top-container">
          <BackArrowIcon color="#000000" style={{ marginTop: '8px' }} />
          <div className="sl-variant-text-container">
            <div className="sl-variant-text-title">Select Variants</div>
            <div className="sl-variant-text-sub-title">Please select the variants you want to send to the creator</div>
          </div>
        </div>
        {loadingVariant ? (
          <div className="sl-variant-loader">
            <SaralLoaderImage />
          </div>
        ) : (
          <div
            className="select-variants-container"
            style={{
              overflowX: selectedProducts.length > 4 ? 'scroll' : 'hidden',
              justifyContent: selectedProducts.length > 4 ? 'flex-start' : 'center',
            }}>
            {selectedProducts?.length > 0 &&
              selectedProducts?.map((product, index) => (
                <VariantSelectionCard
                  key={product.id}
                  {...product}
                  removeProduct={removeProduct}
                  quantities={quantities}
                  setQuantities={setQuantities}
                  allOptions={allOptions}
                  setAllOptions={setAllOptions}
                  cloneObject={cloneObject}
                  productIndex={index}
                />
              ))}
          </div>
        )}
      </div>
      <div className="modal-footer-button-container">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            width: '100%',
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              justifyContent: 'flex-end',
            }}>
            <ButtonComponent
              onClick={() => {
                onClose();
                setSelectedProducts([]);
                setAllOptions({});
                setQuantities({});
              }}
              variant="secondary"
              style={{ maxWidth: '200px', flex: 'auto' }}>
              Back
            </ButtonComponent>
            {/*  */}
            {checkIfDisabled() ? (
              <CustomTooltip arrow title="Select all variants to ship" placement="right">
                <ButtonComponent
                  style={{
                    maxWidth: '200px',
                    flex: 'auto',
                    backgroundColor: 'var(--dark-grey)',
                    opacity: 0.5,
                  }}>
                  Ship ({selectedProducts.length}) Products
                </ButtonComponent>
              </CustomTooltip>
            ) : (
              <ButtonComponent
                onClick={() => {
                  onClose();
                }}
                style={{ maxWidth: '200px', flex: 'auto' }}
                disabled={checkIfDisabled()}
                showLoading={false}>
                Select ({selectedProducts.length}) Products
              </ButtonComponent>
            )}
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default SelectVariant;
